// removed by extract-text-webpack-plugin
module.exports = {"component":"qKF3LhQe"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/utils/baseComponent.styles.scss
// module id = 368
// module chunks = 0